'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';

import { DownloadPreviewImage } from '@/assets';
import { HeroContent } from '@/components/widgets/HeroContent';

export default function HeroSection() {
  return (
    <section className="section bg-gradient-to-br from-white from-50% to-primary-200 pb-8">
      <div className="section-container section z-10 grid size-full grid-cols-1 flex-col gap-10 px-0 py-8 md:gap-16 md:py-20 lg:grid-cols-2 xl:justify-between xl:gap-20">
        <HeroContent />
        <motion.div
          // initial={{ opacity: 0, y: 40 }}
          // whileInView={{ opacity: 1, y: 0 }}
          // viewport={{ once: true }}
          // transition={{ duration: 0.3 }}
          // whileHover={{ y: -5 }}
          className="flex size-full items-center justify-center"
        >
          <motion.div
          // animate={{ y: [0, -10, 0] }}
          // transition={{
          //   duration: 3,
          //   repeat: Infinity,
          //   repeatType: 'reverse',
          // }}
          >
            <Image
              src={DownloadPreviewImage}
              alt="App Preview"
              className="object-cover"
              priority
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
